import SavedAlternatePaymentRadio from 'components/FrictionlessCheckout/PaymentReleaseFour/PaymentMethodList/SavedAlternatePaymentRadio/SavedAlternatePaymentRadio';

export default SavedAlternatePaymentRadio;
